import React from 'react';
import { Box } from '@mui/material';
import ComponentTypesDashboard from '../../components/maintenance/componentTypes/ComponentTypesDashboard';

const TiposComponentePage = () => {  

  return (
    <Box sx={{ p: 2 }}>
      <ComponentTypesDashboard
        onReorder={(newOrder) => {
          console.log('Nuevo orden de tipos de componentes:', newOrder);
        }}
      />
    </Box>
  );
};

export default TiposComponentePage;